import "./App.css";
import { Route, Routes, BrowserRouter as Router } from "react-router-dom";
import Login from "./pages/auth/Login";
import Dashboard from "./pages/Dashboard";
// eslint-disable-next-line no-unused-vars
import PettyCashList from "./pages/petty_cash/PettyCashList";
// eslint-disable-next-line no-unused-vars
import PettyCashDetail from "./pages/petty_cash/PettyCashDetail";
import PettyCashFundRequests from "./pages/petty_cash/PettyCashFundRequests";
import PettyCashEntities from "./pages/petty_cash/PettyCashEntities";
import PettyCashSettings from "./pages/petty_cash/PettyCashSettings";
import { SocketProvider } from "./context/SocketContext";

import ProtectedRoutes from "./Routes/ProtectedRoutes";
import PageNotFound from "./pages/errors/PageNotFound";
import Layout from "./components/layout/Layout";
import { GOOGLE_CLIENT_ID } from "./config";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Toaster } from "react-hot-toast";
import ForgotPassword from "./pages/auth/ForgotPassword";
import Invite from "./pages/auth/Invite";
import useHasProductAccess from "./hooks/useHasProductAccess";
import ProductAccessScreen from "./components/sections/ProductAccessScreen";

import BrandMetadataSync from "./components/BrandMetadataSync";

function App() {
  const { isCheckingAccess, hasAccess } = useHasProductAccess();

  return (
    <>
      <ProductAccessScreen
        isCheckingAccess={isCheckingAccess}
        hasAccess={hasAccess}
      />
      <div className={hasAccess ? "" : "usr82183120"}>
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
          <Router>
            <BrandMetadataSync />
            <Toaster position="top-right" />
            <SocketProvider>
              <Routes>
                <Route path="/login" exact element={<Login />} />
                <Route path="/invite" exact element={<Invite />} />
                <Route
                  path="/forgot-password"
                  exact
                  element={<ForgotPassword />}
                />
                <Route element={<ProtectedRoutes />}>
                  <Route element={<Layout />}>
                    <Route path="/" exact element={<PettyCashList />} />
                    <Route
                      path="/petty-cash/fund-requests"
                      exact
                      element={<PettyCashFundRequests />}
                    />
                    <Route
                      path="/petty-cash/entities"
                      exact
                      element={<PettyCashEntities />}
                    />
                    <Route
                      path="/petty-cash/settings"
                      exact
                      element={<PettyCashSettings />}
                    />
                    <Route
                      path="/petty-cash/:id"
                      exact
                      element={<PettyCashDetail />}
                    />
                  </Route>
                  <Route path="*" exact element={<PageNotFound />} />
                </Route>
              </Routes>
            </SocketProvider>
          </Router>
        </GoogleOAuthProvider>
      </div>
    </>
  );
}

export default App;
